import * as sharedTypes from 'shared/redux/actionTypes';

import * as types from '../actionTypes';

const defaultState = {
  currentView: undefined,
  hasToolbar: undefined,
  type: undefined,
};

export default function reducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.CHANGE_VIEW: {
      // Storing an instance is less than ideal (see http://redux.js.org/docs/faq/OrganizingState.html#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)
      // but it would require some refactoring to avoid it.
      const {
        viewInstance: currentView,
        hasToolbar,
        viewType,
      } = action.payload;
      return {
        currentView,
        hasToolbar,
        viewType,
      };
    }

    case sharedTypes.DELETE_USER:
      return defaultState;

    default:
      return state;
  }
}
